import React from 'react';
import { Box, Typography, ButtonBase } from '@mui/material';

export type EmployeeCategory = 'regular' | 'businessService' | 'dailyWorker';

interface EmployeeCategorySelectorProps {
  value: EmployeeCategory | null;
  onChange: (category: EmployeeCategory) => void;
}

const CATEGORIES: Array<{
  key: EmployeeCategory;
  title: string;
  description: string;
}> = [
  {
    key: 'regular',
    title: '정규 직원',
    description: '월급제 · 시급제 (4대보험)',
  },
  {
    key: 'businessService',
    title: '용역 · 외주',
    description: '사업소득 3.3% 원천',
  },
  {
    key: 'dailyWorker',
    title: '일용근로',
    description: '일당 · 단기 아르바이트',
  },
];

const EmployeeCategorySelector: React.FC<EmployeeCategorySelectorProps> = ({
  value,
  onChange,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    <Typography variant="body1" sx={{ fontWeight: 600, color: 'var(--fg-strong)' }}>
      어떤 유형의 직원인가요?
    </Typography>
    {CATEGORIES.map((cat) => {
      const selected = value === cat.key;
      return (
        <ButtonBase
          key={cat.key}
          onClick={() => onChange(cat.key)}
          sx={{
            width: '100%',
            textAlign: 'left',
            p: 2,
            borderRadius: 2,
            border: selected ? '2px solid var(--primary)' : '1px solid var(--border-default)',
            bgcolor: selected ? 'var(--bg-green)' : 'var(--bg-base)',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            transition: 'border-color 0.15s, background-color 0.15s',
          }}
        >
          <Box>
            <Typography sx={{ fontWeight: 700, color: 'var(--fg-strong)', fontSize: '1.0625rem' }}>
              {cat.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'var(--fg-tertiary)', mt: 0.25 }}>
              {cat.description}
            </Typography>
          </Box>
        </ButtonBase>
      );
    })}
  </Box>
);

export default EmployeeCategorySelector;
